module.exports = __webpack_public_path__ + "static/img/location.68b9376.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/explore/location.png
// module id = tfxR
// module chunks = 2